<template>
    <div class="numpad">
        <div class="row">
            <div class="button" v-on:click="onNumberClick(1)">1</div>
            <div class="button" v-on:click="onNumberClick(2)">2</div>
            <div class="button" v-on:click="onNumberClick(3)">3</div>
        </div>
        <div class="row">
            <div class="button" v-on:click="onNumberClick(4)">4</div>
            <div class="button" v-on:click="onNumberClick(5)">5</div>
            <div class="button" v-on:click="onNumberClick(6)">6</div>
        </div>
        <div class="row">
            <div class="button" v-on:click="onNumberClick(7)">7</div>
            <div class="button" v-on:click="onNumberClick(8)">8</div>
            <div class="button" v-on:click="onNumberClick(9)">9</div>
        </div>
        <div class="row">
            <div class="button back" v-on:click="onBackClick()">
                <img src="images/icons/left-arrow-to-left.svg" />
            </div>
            <div class="button" v-on:click="onNumberClick(0)">0</div>
            <div class="button clear" v-on:click="onClearClick()">
                <img src="images/icons/times-circle.svg" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    methods: {
        onNumberClick(number) {
            const value = this.value + number;
            this.$emit('input', value);
        },
        onBackClick() {
            let value = this.value;
            if (value.length > 0) {
                value = value.substring(0, value.length - 1);
                this.$emit('input', value);
            }
        },
        onClearClick() {
            this.$emit('input', '');
        },
    },
};
</script>
